import { inject, Injectable } from '@angular/core';
import { AuthToken } from '@libs/shared/models';
import { from, Observable } from 'rxjs';
import { AuthTokenState } from '../state';

@Injectable({
  providedIn: 'root',
})
export class UserAuthService {
  private readonly state: AuthTokenState = inject(AuthTokenState);

  public reset(): void {
    this.state.reset();
  }

  public readToken(): Observable<AuthToken | undefined> {
    return this.state.readToken();
  }

  public updateToken(token: AuthToken | undefined): Observable<void> {
    return from(this.state.updateToken(token));
  }

  public refreshToken(): Observable<AuthToken | undefined> {
    return from(this.state.refresh());
  }

  public login(): Observable<void> {
    return from(this.state.login());
  }

  public logout(): Observable<void> {
    return from(this.state.logout());
  }
}
